import React from "react";

export default () => {

    return <svg xmlns="http://www.w3.org/2000/svg" width="41" height="41" viewBox="0 0 41 41">
        <g transform="translate(-301 -123)">
            <circle cx="20.5" cy="20.5" r="20.5" transform="translate(301 123)" fill="#0093ff"/>
            <line x2="13" y2="13" transform="translate(315.5 137)" fill="none" stroke="#fff" strokeLinecap="round" strokeWidth="3"/>
            <line x1="13" y2="13" transform="translate(315 137)" fill="none" stroke="#fff" strokeLinecap="round" strokeWidth="3"/>
        </g>
    </svg>;

}
